package com.iptvplayer.shared.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.iptvplayer.shared.domain.repository.WatchHistoryRepository
import com.iptvplayer.shared.presentation.state.HistoryUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class HistoryViewModel(
    private val watchHistoryRepository: WatchHistoryRepository
) : ViewModel() {

    private val _state = MutableStateFlow(HistoryUiState())
    val state: StateFlow<HistoryUiState> = _state.asStateFlow()

    init {
        loadHistory()
    }

    private fun loadHistory() {
        viewModelScope.launch {
            _state.update { it.copy(isLoading = true) }
            watchHistoryRepository.getHistory(50).collect { history ->
                _state.update { it.copy(history = history, isLoading = false) }
            }
        }
    }

    fun removeHistory(contentId: String) {
        viewModelScope.launch {
            watchHistoryRepository.removeHistory(contentId)
        }
    }

    fun syncHistory() {
        viewModelScope.launch {
            watchHistoryRepository.syncHistory()
        }
    }
}
